import iconUrl from './assets/icon.svg';

type Props = {
  style?: React.CSSProperties;
};

export const UserAvatarWithFlag = ({ style }: Props) => {
  return <img src={iconUrl} alt="" style={style} />;
};
